import GroupSelect, { type Group } from 'component/groupSelect'
import React from 'react'
// 排序方式, topAndUsed-最近更新, recentOpen-最近打开, recentCreate-最新创建, oldestCreate-最老创建, addSample-最近添加样衣优先
export const RANK_STATUS = { recentlyUpdated: 'topAndUsed',
  new: 'recentCreate',
  earliestCreated: 'oldestCreate',
  recentlyOpened: 'recentOpen' }
export const QUERY_TYPE = { all: 'all', mine: 'mine', operable: 'operable' }

const GROUPS: Group[] = [
  {
    label: '排序',
    key: '1',
    options: [
      { label: '最近更新', value: RANK_STATUS.recentlyUpdated },
      { label: '最近打开', value: RANK_STATUS.recentlyOpened },
      { label: '最新创建', value: RANK_STATUS.new },
      { label: '最早创建', value: RANK_STATUS.earliestCreated },
    ]
  },
  {
    label: '范围',
    key: '2',
    options: [
      { label: '我新建的', value: QUERY_TYPE.mine },
      { label: '全部文件夹', value: QUERY_TYPE.all },
    ]
  }
]
type RankAndScopeSelectProps = {
  rank: string,
  scope: string,
  onChange: (sort: string, scope: string) => void
}
export default function RankAndScopeSelect({
  rank,
  scope,
  onChange
}:RankAndScopeSelectProps) {
  return <GroupSelect
    displayTextClassName="fill-grey-bg"
    values={[rank, scope]}
    onChange={
    ([_sort, _scope]) => onChange(_sort as string, _scope as string)
  }
    groups={GROUPS}
  />
}
